import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { FaHome, FaBoxOpen, FaPlus, FaHistory } from "react-icons/fa";
import "./BottomNavbar.css";

const BottomNavbar = () => {
  const navigate = useNavigate();

  const handleAddClick = () => {
    navigate("/user/add-reference");
  };

  return (
    <footer className="user-bottom-navbar">
      <NavLink to="/user/dashboard" className="user-nav-item">
        <FaHome />
        <span>Dashboard</span>
      </NavLink>

      <NavLink to="/user/products" className="user-nav-item">
        <FaBoxOpen />
        <span>Products</span>
      </NavLink>

      <button className="user-add-btn" onClick={handleAddClick}>
        <FaPlus />
        <span>Add Ref</span>
      </button>

      <NavLink to="/user/history" className="user-nav-item">
        <FaHistory />
        <span>History</span>
      </NavLink>
    </footer>
  );
};

export default BottomNavbar;
